import React, { useEffect, useRef, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../Loader'
import { axiosInstance } from '../Config'

const onlyDigits = (e) => { if (!/[0-9]/.test(e.key)) e.preventDefault() }
const onlyLetters = (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return
    if (e.key.length !== 1) return
    if (!/^[A-Za-z ]$/.test(e.key)) e.preventDefault()
}
const sanitizeName = (v) => v.replace(/[^A-Za-z ]/g, "").replace(/\s{2,}/g, " ").replace(/^\s+/, "")

const AddTutor = () => {
    const [profilePreview, setProfilePreview] = useState(null)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [gender, setGender] = useState('')
    const [address, setAddress] = useState('')
    const [qualification, setQualification] = useState('')
    const [specialization, setSpecialization] = useState('')
    const [aadhar, setAadhar] = useState('')
    const [pan, setPan] = useState('')
    const [pricePerSession, setPricePerSession] = useState('')
    const [accountHolder, setAccountHolder] = useState('')
    const [bankName, setBankName] = useState('')
    const [accountNumber, setAccountNumber] = useState('')
    const [ifsc, setIfsc] = useState('')
    const [aadharDocPreview, setAadharDocPreview] = useState(null)
    const [panDocPreview, setPanDocPreview] = useState(null)
    const [lightboxSrc, setLightboxSrc] = useState(null)
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const fileRef = useRef(null)
    const aadharDocRef = useRef(null)
    const panDocRef = useRef(null)
    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Add Tutor | Mindora'
        window.scrollTo(0, 0)
    }, [])

    const validate = () => {
        const e = {}
        if (!name.trim()) e.name = 'Name is required'
        else if (!/^[A-Za-z ]+$/.test(name.trim())) e.name = 'Name should contain only letters and spaces'
        else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(name.trim())) e.name = 'Name should contain only letters and spaces'
        if (!email.trim()) e.email = 'Email is required'
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = 'Invalid email format'
        if (!phone.trim()) e.phone = 'Phone number is required'
        else if (phone.length !== 10) e.phone = 'Phone must be 10 digits'
        if (!gender) e.gender = 'Gender is required'
        if (!address.trim()) e.address = 'Address is required'
        if (!qualification.trim()) e.qualification = 'Qualification is required'
        if (aadhar && aadhar.length !== 12) e.aadhar = 'Aadhar must be 12 digits'
        if (pan && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) e.pan = 'Invalid PAN format (e.g. ABCDE1234F)'
        setErrors(e)
        return Object.keys(e).length === 0
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!validate()) return
        setLoading(true)
        const fd = new FormData()
        fd.append('name', name)
        fd.append('email', email)
        fd.append('phone', phone)
        fd.append('gender', gender)
        fd.append('address', address)
        fd.append('qualification', qualification)
        if (specialization) fd.append('specialization', specialization)
        if (pricePerSession) fd.append('pricePerSession', pricePerSession)
        if (aadhar) fd.append('aadhar', aadhar)
        if (pan) fd.append('pan', pan)
        if (accountHolder) fd.append('accountHolder', accountHolder)
        if (bankName) fd.append('bankName', bankName)
        if (accountNumber) fd.append('accountNumber', accountNumber)
        if (ifsc) fd.append('ifsc', ifsc)
        if (fileRef.current?.files[0]) fd.append('profileImage', fileRef.current.files[0])
        if (aadharDocRef.current?.files[0]) fd.append('aadharDoc', aadharDocRef.current.files[0])
        if (panDocRef.current?.files[0]) fd.append('panDoc', panDocRef.current.files[0])

        axiosInstance.post('/tutors', fd)
            .then(() => {
                toast.success('Tutor added successfully!')
                navigate(-1)
            })
            .catch(err => toast.error(err.response?.data?.message || 'Failed to add tutor'))
            .finally(() => setLoading(false))
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Add Tutor" description="Create a new tutor">
                <div className="p-4 py-5 bg-gradientt rounded-4">
                    <section className="ps-dashboards" id="homepages">
                        <form onSubmit={handleSubmit} className="therapist-profile-form">
                            <div className="row px-md-5">

                                {/* Profile image */}
                                <div className="col-12 d-flex justify-content-center mb-4">
                                    <div className="tutor-avatar-upload" onClick={() => fileRef.current.click()}>
                                        {profilePreview
                                            ? <img src={profilePreview} alt="Profile" />
                                            : <div className="tutor-avatar-placeholder">
                                                <i className="bi bi-person" style={{ fontSize: 40, color: 'var(--primary)' }}></i>
                                              </div>
                                        }
                                        <div className="tutor-avatar-edit">
                                            <i className="bi bi-camera-fill"></i>
                                        </div>
                                    </div>
                                    <input ref={fileRef} type="file" accept="image/*" hidden
                                        onChange={(e) => {
                                            const file = e.target.files[0]
                                            if (file) setProfilePreview(URL.createObjectURL(file))
                                        }} />
                                </div>

                                {/* Personal Info */}
                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="name" className='label'>
                                            <input type="text" id="name" placeholder="Name"
                                                value={name} onKeyDown={onlyLetters} onKeyPress={onlyLetters}
                                                onChange={(e) => setName(sanitizeName(e.target.value))}
                                                onPaste={(e) => {
                                                    e.preventDefault()
                                                    const t = (e.clipboardData || window.clipboardData).getData('text')
                                                    const s = sanitizeName(t)
                                                    const start = e.target.selectionStart
                                                    const end = e.target.selectionEnd
                                                    const next = sanitizeName(name.slice(0, start) + s + name.slice(end))
                                                    setName(next)
                                                }} />
                                            <span>Full Name <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.name && <span className='badge text-danger span-error'>{errors.name}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="email" className='label'>
                                            <input type="text" id="email" placeholder="Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value.toLowerCase())} />
                                            <span>Email <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.email && <span className='badge text-danger span-error'>{errors.email}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="phone" className='label'>
                                            <input type="text" id="phone" placeholder="Phone Number"
                                                value={phone} maxLength={10} onKeyPress={onlyDigits}
                                                onChange={(e) => setPhone(e.target.value)} />
                                            <span>Phone Number <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.phone && <span className='badge text-danger span-error'>{errors.phone}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="gender" className='label'>
                                            <select id="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
                                                <option value="">Select Gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            <span>Gender <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.gender && <span className='badge text-danger span-error'>{errors.gender}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="qualification" className='label'>
                                            <input type="text" id="qualification" placeholder="Qualification"
                                                value={qualification}
                                                onChange={(e) => setQualification(e.target.value)} />
                                            <span>Qualification <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.qualification && <span className='badge text-danger span-error'>{errors.qualification}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="pricePerSession" className='label'>
                                            <input type="text" id="pricePerSession" placeholder="Price Per Session"
                                                value={pricePerSession} onKeyPress={onlyDigits}
                                                onChange={(e) => setPricePerSession(e.target.value)} />
                                            <span>Price Per Session (₹)</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-12 px-4">
                                    <div className="input-field">
                                        <label htmlFor="specialization" className='label'>
                                            <input type="text" id="specialization" placeholder="Specialization"
                                                value={specialization}
                                                onChange={(e) => setSpecialization(e.target.value)} />
                                            <span>Specialization</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-12 px-4">
                                    <div className="input-field">
                                        <label htmlFor="address" className='label'>
                                            <input type="text" id="address" placeholder="Address"
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)} />
                                            <span>Address <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.address && <span className='badge text-danger span-error'>{errors.address}</span>}
                                </div>

                                {/* Bank Details */}
                                <div className="col-12 px-4 mt-4 mb-2">
                                    <div className="tutor-section-label">
                                        <i className="bi bi-bank me-2"></i>Bank Details
                                    </div>
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="accountHolder" className='label'>
                                            <input type="text" id="accountHolder" placeholder="Account Holder Name"
                                                value={accountHolder}
                                                onChange={(e) => setAccountHolder(e.target.value)} />
                                            <span>Account Holder Name</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="bankName" className='label'>
                                            <input type="text" id="bankName" placeholder="Bank Name"
                                                value={bankName}
                                                onChange={(e) => setBankName(e.target.value)} />
                                            <span>Bank Name</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="accountNumber" className='label'>
                                            <input type="text" id="accountNumber" placeholder="Account Number"
                                                value={accountNumber} onKeyPress={onlyDigits}
                                                onChange={(e) => setAccountNumber(e.target.value)} />
                                            <span>Account Number</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="ifsc" className='label'>
                                            <input type="text" id="ifsc" placeholder="IFSC Code"
                                                value={ifsc} maxLength={11}
                                                onChange={(e) => setIfsc(e.target.value.toUpperCase())} />
                                            <span>IFSC Code</span>
                                        </label>
                                    </div>
                                </div>

                                {/* Official Documents */}
                                <div className="col-12 px-4 mt-4 mb-2">
                                    <div className="tutor-section-label">
                                        <i className="bi bi-file-earmark-text me-2"></i>Official Documents
                                    </div>
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="aadhar" className='label'>
                                            <input type="text" id="aadhar" placeholder="Aadhar Number"
                                                value={aadhar} maxLength={12} onKeyPress={onlyDigits}
                                                onChange={(e) => setAadhar(e.target.value)} />
                                            <span>Aadhar Number</span>
                                        </label>
                                    </div>
                                    {errors.aadhar && <span className='badge text-danger span-error'>{errors.aadhar}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="pan" className='label'>
                                            <input type="text" id="pan" placeholder="PAN Number"
                                                value={pan} maxLength={10}
                                                onChange={(e) => setPan(e.target.value.toUpperCase())} />
                                            <span>PAN Number</span>
                                        </label>
                                    </div>
                                    {errors.pan && <span className='badge text-danger span-error'>{errors.pan}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <p className="mb-2" style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Aadhar Card</p>
                                    <div className="tutor-doc-upload" onClick={() => aadharDocRef.current.click()}>
                                        {aadharDocPreview
                                            ? <>
                                                <img src={aadharDocPreview} alt="Aadhar" />
                                                <button type="button"
                                                    onClick={(e) => { e.stopPropagation(); setLightboxSrc(aadharDocPreview) }}
                                                    style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.55)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 3 }}>
                                                    <i className="bi bi-eye" style={{ fontSize: 14 }}></i>
                                                </button>
                                              </>
                                            : <div className="tutor-doc-placeholder">
                                                <i className="bi bi-card-heading"></i>
                                                <span>Click to upload Aadhar</span>
                                              </div>
                                        }
                                        <div className="tutor-doc-overlay">
                                            <i className="bi bi-camera-fill me-1"></i>
                                            {aadharDocPreview ? 'Change' : 'Upload'}
                                        </div>
                                    </div>
                                    <input ref={aadharDocRef} type="file" accept="image/*" hidden
                                        onChange={(e) => {
                                            const file = e.target.files[0]
                                            if (file) setAadharDocPreview(URL.createObjectURL(file))
                                        }} />
                                </div>

                                <div className="col-md-6 px-4">
                                    <p className="mb-2" style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>PAN Card</p>
                                    <div className="tutor-doc-upload" onClick={() => panDocRef.current.click()}>
                                        {panDocPreview
                                            ? <>
                                                <img src={panDocPreview} alt="PAN" />
                                                <button type="button"
                                                    onClick={(e) => { e.stopPropagation(); setLightboxSrc(panDocPreview) }}
                                                    style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.55)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 3 }}>
                                                    <i className="bi bi-eye" style={{ fontSize: 14 }}></i>
                                                </button>
                                              </>
                                            : <div className="tutor-doc-placeholder">
                                                <i className="bi bi-credit-card-2-front"></i>
                                                <span>Click to upload PAN</span>
                                              </div>
                                        }
                                        <div className="tutor-doc-overlay">
                                            <i className="bi bi-camera-fill me-1"></i>
                                            {panDocPreview ? 'Change' : 'Upload'}
                                        </div>
                                    </div>
                                    <input ref={panDocRef} type="file" accept="image/*" hidden
                                        onChange={(e) => {
                                            const file = e.target.files[0]
                                            if (file) setPanDocPreview(URL.createObjectURL(file))
                                        }} />
                                </div>

                                <div className="col-12 text-center mt-5">
                                    <button type="button" onClick={() => navigate(-1)}
                                        className="button me-4"
                                        style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}>
                                        <i className='icon-arrow-left me-2'></i>Back
                                    </button>
                                    <button type="submit" className="btn-green button" disabled={loading}>
                                        <i className={`bi bi-${loading ? 'arrow-repeat rotation' : 'save'} me-2`}></i>
                                        Save
                                    </button>
                                </div>

                            </div>
                        </form>
                    </section>
                </div>
            </ContainerDashboard>
            {lightboxSrc && (
                <div
                    onClick={() => setLightboxSrc(null)}
                    style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out' }}>
                    <img src={lightboxSrc} alt="Preview"
                        style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8, boxShadow: '0 8px 40px rgba(0,0,0,0.5)' }} />
                    <button
                        onClick={() => setLightboxSrc(null)}
                        style={{ position: 'absolute', top: 20, right: 20, background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%', width: 38, height: 38, color: '#fff', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        ✕
                    </button>
                </div>
            )}
        </>
    )
}

export default AddTutor
